import { useEffect } from 'react';
import { useMutation } from '@apollo/client';

import {
  SET_ON_CONTINUE,
  SET_LOADING,
  SET_SUCCESS,
} from '../../reducers/actionReducer';
import LoadingSpinner from '../LoadingSpinner';
import ErrorText from '../ErrorText';
import { CUSTOM_PACKAGES_QUERY } from '../../queries';
import { DELETE_PACKAGE } from '../../mutations';

export default function DeletePackage({
  dispatchAction,
  packageId,
  packageName,
}) {
  const [deletePackage, { loading, error, called, data }] = useMutation(
    DELETE_PACKAGE,
    {
      refetchQueries: [CUSTOM_PACKAGES_QUERY],
    }
  );

  useEffect(() => {
    if (packageId && deletePackage) {
      dispatchAction({
        type: SET_ON_CONTINUE,
        payload: {
          onContinue: () => deletePackage({ variables: { packageId } }),
        },
      });
    }
  }, [dispatchAction, deletePackage, packageId]);

  useEffect(() => {
    if (loading !== undefined) {
      dispatchAction({
        type: SET_LOADING,
        payload: { loading },
      });
    }
  }, [dispatchAction, loading]);

  useEffect(() => {
    if (called && data && !error) {
      dispatchAction({
        type: SET_SUCCESS,
        payload: {
          message: 'Package deleted successfully.',
        },
      });
    }
  }, [called, data, dispatchAction, error]);

  return (
    <div className="flex flex-col justify-center items-center text-center space-y-3 w-full p-2 min-h-[200px]">
      {loading && <LoadingSpinner />}
      {error && <ErrorText message={error.message} />}
      {!loading && !error && (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <div className="space-y-2">
            <p className="font-semibold text-red-700 text-sm">
              This will permanently delete package: {packageName}
            </p>
            <p className="text-xs text-gray-600">
              Would you like to continue with the deletion of this package?
            </p>
          </div>
        </>
      )}
    </div>
  );
}
